<template>
  <div>
    <v-row>
      <v-col>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Orders (period)" :disabled="true" v-model="data.updateOrders"></v-text-field>
            <p>Sale Report (sync orders from FlameHub)</p>
          </v-card-text>
        </v-card>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Orders (daily)" :disabled="true" v-model="data.updateOrdersDaily"></v-text-field>
            <p>Sale Report (link call to orders)</p>
          </v-card-text>
        </v-card>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Rank (daily)" :disabled="true" v-model="data.updateRank"></v-text-field>
            <p>Settings->Rank, Sale Report->Rank\Rank History</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Active Campaign (period)" :disabled="true" v-model="data.updateActiveCampaign"></v-text-field>
            <p>Sale Report->First\Top CPC, update keyword position</p>
          </v-card-text>
        </v-card>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Analytic (daily)" :disabled="true" v-model="data.updateAnalytic"></v-text-field>
            <p>Sale Report->GA Client Id\Search Query</p>
          </v-card-text>
        </v-card>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Web Inquiries (daily)" :disabled="true" v-model="data.updateWebInq"></v-text-field>
            <p>Sale Report->Web Inquire Id</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Google Ads (daily)" :disabled="true" v-model="data.updateGoogleAds"></v-text-field>
            <p>Sync Campaign\Ads\Keyword</p>
          </v-card-text>
        </v-card>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Bing Ads (daily)" :disabled="true" v-model="data.updateBingAds"></v-text-field>
            <p>Sync Campaign\Ads\Keyword</p>
          </v-card-text>
        </v-card>
        <v-card class="mt-7 d-none" >
          <v-card-text>
            <v-text-field type="text" label="CRM (daily)" :disabled="true" v-model="data.updateCopper"></v-text-field>
            <p>CRM Report</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Grashopper (daily)" :disabled="true" v-model="data.updateGrashopper"></v-text-field>
            <p>Import Calls</p>
          </v-card-text>
        </v-card>
         <v-card class="mt-7">
          <v-card-text>
            <v-text-field type="text" label="Update Quckbooks (daily)" :disabled="true" v-model="data.updateQuickbooks"></v-text-field>
            <p>Internal Table, Report->Customers</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '@/api/axios-auth'

export default {
  data() {
    return {
      hideAnything: false,
      data: {},
      userName: null,
    }
  },
  mounted() {
    axios
      .get('/username')
      .then(response => (this.userName = response.data))

    axios
      .get('/settings/status')
      .then(response => (this.data = response.data))
  }
}
</script>

<style scoped>

</style>